import React from 'react';
import { Link } from 'react-router-dom';
import Component from '../../components/Component';
import { Alert, Box, Button, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

/**
 * Admin UI for social seed was removed.
 * Bot followers for the top active users are applied via a backend script only.
 */
function SocialSeed() {
  return (
    <Component>
      <Box sx={{ p: 2, maxWidth: 720 }}>
        <Button component={Link} to="/users/create" startIcon={<ArrowBackIcon />} size="small" sx={{ mb: 2 }}>
          Create User
        </Button>
        <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
          Bot followers
        </Typography>
        <Alert severity="info" sx={{ mb: 2 }}>
          This is no longer an admin form. Run the backend script so ~45 Create User bots each follow a
          share of the top 10k active users (5 bot followers per user) and send follow notifications.
        </Alert>
        <Typography variant="body2" component="pre" sx={{ bgcolor: '#f5f5f5', p: 2, borderRadius: 1, overflow: 'auto' }}>
{`# dry run
npx ts-node -r dotenv/config src/Scripts/seedBotFollowersForActiveUsers.ts --dryRun=1

# apply (follows + notifications)
npx ts-node -r dotenv/config src/Scripts/seedBotFollowersForActiveUsers.ts`}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Docs: dugout-be <code>docs/BOT_FOLLOWERS_SCRIPT.md</code>
        </Typography>
      </Box>
    </Component>
  );
}

export default SocialSeed;
